import { observer } from 'mobx-react';
import { FC } from 'react';
import takerGoStore from '../../store/takerGoStore';
import { ORDER_STATUS } from '~/constants/order';
import { localeStore } from '~/mobx/localesStore';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Picker from '~/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import Text from '~/view/components/Text/Text';

const OrderStatus: FC = observer((): JSX.Element => {
  const orderStatusOptions: IPickerOption[] = [
    { label: localeStore.t(`${ORDER_STATUS.ACCEPTED}_status`), value: ORDER_STATUS.ACCEPTED },
    { label: localeStore.t(`${ORDER_STATUS.PROCESSING}_status`), value: ORDER_STATUS.PROCESSING },
    { label: localeStore.t(`${ORDER_STATUS.WAITING_FOR_PICKUP}_status`), value: ORDER_STATUS.WAITING_FOR_PICKUP },
  ];

  const selectedOption = [{ label: localeStore.t(`${takerGoStore.settings.orderStatus}_status`), value: takerGoStore.settings.orderStatus }];

  const handleOptionChange = (options: IPickerOption[]) => {
    const selectedOption = options?.[0];
    takerGoStore.changeSettings({ orderStatus: selectedOption.value });
  };

  return (
    <div className="d-flex align-items-center">
      <Text
        type="order-field"
        text="order_status"
        tooltip={{ position: TOOLTIP_POSITION.PORTAL, message: localeStore.t('status_in_delivery_service') }}
        className="integration-settings__field"
        wrapperClassName="w-40"
      />

      <Picker
        selectedOptions={selectedOption}
        options={orderStatusOptions}
        onSelect={handleOptionChange}
        hideSelectedIcons
        hideResetIcon
        className="flex-1"
      />
    </div>
  );
});

export default OrderStatus;
